import Navbar from '../components/NavbarDashboard';
import NavbarMobile from '../components/NavbarDashboardMobile';
import styles from '../styles/Dashboard.module.css';
import { UserContext } from '../lib/context';
import { firestore, serverTimestamp } from '../lib/firebase';
import { useState, useEffect, useContext } from 'react';
import { useRouter } from 'next/router';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { mp } from '../lib/mixpanel';

export default function Dashboard() {
  return (
    <>
      <Navbar />
      <Body />
    </>
  );
}

function Body() {
  const { user, userData, userConsults } = useContext(UserContext);
  const [lastConsult, setLastConsult] = useState(false);
  const [userLoaded, setUserLoaded] = useState(false);
  const [userDataLoaded, setUserDataLoaded] = useState(false);
  const [userConsultsLoaded, setUserConsultsLoaded] = useState(false);
  const [stateLoaded, setStateLoaded] = useState(false);
  const [status, setStatus] = useState(null);
  const [completedSurvey, setCompletedSurvey] = useState(false);
  const router = useRouter();

  useEffect(() => {
    // console.log(user?.uid);
    if (user) {
      setUserLoaded(true);
      mp.track('referral_view_cta', {
        userID: user.uid,
        name: 'dashboard page',
      });
      console.log(router.pathname);
    }
  }, [user]);

  const clickRefer = () => {
    mp.track('referral_click_cta', {
      userID: user.uid,
      name: 'dashboard page',
    });
    router.push('/refer');
  };

  useEffect(() => {
    if (userData?.referralChannel) {
      setCompletedSurvey(true);
    }
    if (userData) {
      setUserDataLoaded(true);
    }
  }, [userData]);

  useEffect(() => {
    // console.log(completedSurvey);
  }, [completedSurvey]);

  // How to determine the right consult for this?
  // -- Pull all the consults and select the one that's most advanced?

  useEffect(async () => {
    console.log('Consults ---------------');
    console.log(userConsults);
    if (userConsults == null) {
      setLastConsult(null);
    }
    if (userConsults) {
      // Find the right consult
      if (userConsults.length == 1) {
        setLastConsult(userConsults[0]);
      } else {
        // find the one with the lastest status
        const stat = [
          'in progress',
          'submitted',
          'paid',
          'reviewed',
          'in review',
          'approved',
        ];
        let high = 0;
        let highIndex = 0;
        userConsults.map((consult, i) => {
          let index = stat.indexOf(consult?.data?.status);
          if (index > high) {
            high = index;
            highIndex = i;
          }
        });
        setLastConsult(userConsults[highIndex]);
      }
    }

    if (userConsults) {
      setUserConsultsLoaded(true);
    }
  }, [userConsults]);

  useEffect(() => {
    // 'get started', // Step 0 active --> no consults
    if (lastConsult == null) {
      setStatus('get started');
    }

    // 'in progress', // Step 1 active --> consult.status == in progress OR (consult.status == submitted AND consult.paid == false)
    if (
      lastConsult?.data?.status == 'in progress' ||
      (lastConsult?.data?.status == 'submitted' &&
        lastConsult?.data?.paid == false)
    ) {
      setStatus('in progress');
    }
    // 'paid', //  Step 2 active --> (consult.status == submitted AND consult.paid == undefined) OR consult.status == paid || reviewed || in review

    if (
      (lastConsult?.data?.status == 'submitted' &&
        lastConsult?.data?.paid == undefined) ||
      lastConsult?.data?.status == 'paid' ||
      lastConsult?.data?.status == 'reviewed' ||
      lastConsult?.data?.status == 'in review'
    ) {
      setStatus('paid');
    }
    // 'approved', // Step 3 --> consult.status == approved
    if (lastConsult?.data?.status == 'approved') {
      setStatus('approved');
    }
  }, [lastConsult]);

  useEffect(() => {
    console.log('Dash Status ---------------');
    console.log(status);
  }, [status]);

  useEffect(() => {
    console.log(`User loaded: ${userLoaded}`);
  }, [userLoaded]);
  useEffect(() => {
    console.log(`User data loaded: ${userDataLoaded}`);
  }, [userDataLoaded]);
  useEffect(() => {
    console.log(`User consult loaded: ${userDataLoaded}`);
    if (userLoaded && userDataLoaded) {
      setStateLoaded(true);
    }
  }, [userLoaded, userDataLoaded]);

  useEffect(() => {
    console.log(`State Fully Loaded: ${stateLoaded}`);
  }, [stateLoaded]);

  const survey = () => {
    router.push('/survey');
  };

  // Lifecycle of a consultation
  const lifecycle = [
    'get started', // Step 0 active --> no consults
    'in progress', // Step 1 active --> consult.status == in progress OR (consult.status == submitted AND consult.paid == false)
    'paid', //  Step 2 active --> (consult.status == submitted AND consult.paid == undefined) OR consult.status == paid || reviewed || in review
    'approved', // Step 3 --> consult.status == approved
  ];

  const steps = [
    {
      step: 0,
      title: 'Start medical consultation',
      sub: 'Get started with your virtual visit.',
    },
    {
      step: 1,
      title: 'Complete medical consultation',
      sub: 'Complete the consultation you started.',
    },
    {
      step: 2,
      title: 'Medical review',
      sub: 'Our medical team is reviewing your profile and writing your prescription. This usually takes less than 24 hours.',
    },
    {
      step: 3,
      title: 'Fill prescription',
      sub: 'Our pharmacy is filling your prescription.',
    },
  ];

  const getStarted = () => {
    router.push('/birth-control');
  };

  const continue1 = () => {
    router.push('/consultations');
  };

  const goToChat = () => {
    router.push('/chat');
  };

  const rx1 = () => {
    router.push('/prescriptions');
  };

  return (
    <div className={`${styles['dashboard-container']} red`}>
      <div className={`${styles['dashboard-container-max']} red`}>
        <div className={`${styles['dashboard-item-title-center']} red`}>
          {userData?.firstName
            ? `Welcome, ${userData?.firstName}!`
            : 'Welcome!'}
        </div>
        <div className={`${styles['div-flex-refer']} red`}>
          <div className={`${styles['div-next-max']} red`}>
            {/* If state NOT ready, put a skeleton */}
            {!stateLoaded && (
              <div className={`${styles['dashboard-item-container']} red`}>
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </div>
            )}
            {/* If state IS ready, put the actual UI */}
            {stateLoaded && (
              <>
                {/* {!completedSurvey && (
                  <>
                    <div
                      className={`${styles['dashboard-item-container']} red`}
                    >
                      <div className={`${styles['refer-title']} red`}>
                        How did you hear about Gemma?
                      </div>
                      <div className={`${styles['dashboard-text']} red`}>
                        Let us know who told you about us!
                      </div>
                      <button
                        className={`${styles['take-survey-btn']} red`}
                        onClick={survey}
                      >
                        Take survey
                      </button>
                    </div>
                    <div className={`${styles['input-space']} red`} />
                  </>
                )} */}
                <div
                  className={`${styles['dashboard-item-container-next']} red`}
                >
                  <div className={`${styles['qr-code-container']} red`}>
                    <div>
                      <div className={`${styles['referral-title']} red`}>
                        Invite friends and earn $250! 💰
                      </div>

                      <button
                        onClick={clickRefer}
                        className={`${styles['copy-referral-code']} red`}
                      >
                        Invite friends 🤑
                      </button>
                    </div>
                  </div>
                </div>
                <br />

                <div
                  className={`${styles['dashboard-item-container-next']} red`}
                >
                  <img
                    className={`${styles['image-next']} red`}
                    src="/landing/why6.svg"
                  />
                  <div className={`${styles['refer-title']} red`}>
                    What&apos;s next?
                  </div>
                  <List lifecycle={lifecycle} status={status} steps={steps} />
                  {status == 'get started' && (
                    <button
                      className={`${styles['next-dashboard-btn']} red`}
                      onClick={getStarted}
                    >
                      Get started
                    </button>
                  )}
                  {status == 'in progress' && (
                    <button
                      className={`${styles['next-dashboard-btn']} red`}
                      onClick={continue1}
                    >
                      Continue consultation
                    </button>
                  )}
                  {status == 'paid' && (
                    <button
                      className={`${styles['next-dashboard-btn']} red`}
                      onClick={goToChat}
                    >
                      Chat with medical team
                    </button>
                  )}
                  {status == 'approved' && (
                    <button
                      className={`${styles['next-dashboard-btn']} red`}
                      onClick={rx1}
                    >
                      Go to prescription
                    </button>
                  )}
                </div>
              </>
            )}
            <NavbarMobile />
          </div>
        </div>
      </div>
    </div>
  );
}

function List({ lifecycle, status, steps }) {
  return (
    <ol className={`${styles['dash-next-list']} red`}>
      {steps.map((step, i) => (
        // ITEM
        // States:
        //  complete      if index of status (in the lufecycle array) is larger than i
        //  inprogress    if index of status (in the lufecycle array) is equal to i
        //  incomplete    if index of status (in the lufecycle array) is smaller than i
        <li
          key={`li1-${lifecycle[i]}`}
          className={
            lifecycle.indexOf(status) > i && lifecycle.length - 2 == i
              ? `${styles['dash-next-list-li-last']} red`
              : lifecycle.indexOf(status) > i
              ? `${styles['dash-next-list-li']} red`
              : lifecycle.indexOf(status) < i
              ? `${styles['dash-next-list-li-incomplete']} red`
              : `${styles['dash-next-list-li-inprogress']} red`
          }
        >
          <div
            key={`div2-${lifecycle[i]}`}
            className={
              lifecycle.indexOf(status) > i
                ? `${styles['dash-dot-complete']} red`
                : lifecycle.indexOf(status) < i
                ? `${styles['dash-dot-incomplete']} red`
                : `${styles['dash-dot-inprogress']} red`
            }
          >
            {lifecycle.indexOf(status) > i && <Check />}
          </div>
          <div className={`${styles['dash-dot-contain']} red`}>
            <div
              key={`div3-${lifecycle[i]}`}
              className={
                lifecycle.indexOf(status) > i
                  ? `${styles['dash-dot-title-complete']} red`
                  : `${styles['dash-dot-title']} red`
              }
            >
              {step.title}
            </div>
            {step.sub && lifecycle.indexOf(status) == i && (
              <div
                key={`div4-${lifecycle[i]}`}
                className={`${styles['dash-dot-sub']} red`}
              >
                {step.sub}
              </div>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
}

function Check() {
  return (
    <svg
      className="w-6 h-6"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M5 13l4 4L19 7"
      ></path>
    </svg>
  );
}
